/*globals module, snowdome */

module.exports = {
	$modal: null,
	total: 0,

	init: function() {
		'use strict';

		var that = this;

		this.total = snowdome.Checkout.total;
		this.$modal = $('[data-remodal-id=coupon-redeem]').remodal({
			hashTracking: false,
		});

		$('[data-coupon]').on('input', function() {
			$('[data-coupon-apply]').removeClass('btn--disabled');
		});

		$('[data-coupon-apply]').on('click', function() {
			var code = $('[data-coupon]').val();

			if(!code) {
				return false;
			}

			that.getCoupon(code, function(coupon) {
				if(coupon) {
					that.redeem(coupon);
				}
			});
		});

		$('[data-coupon-redeem]').click(function(e) {
			e.preventDefault();

			that.apply($('#modal-coupon').prop('coupon'), parseFloat($('[data-coupon-amount]').val()));
			that.$modal.close();
		});

		$('[data-coupon-remove]').on('click', function() {
			that.remove();
		});
	},

	/**
	 * Retrieves the details of the coupon for the specified code, if any
	 * @todo Validate/retrieve coupon details here
	 * @param {String} code
	 * @param {Function} callback which will be passed the retrieved coupon, or null if no coupon was found
	 */
	getCoupon: function(code, callback) {
		'use strict';

		callback({
			code: code,
			balance: 96.35,
			expiry: new Date(2018, 11, 25),
		});
	},

	/**
	 * Displays and populates the coupon modal, allowing the user to specify the amount to redeem
	 * @param {Coupon} coupon
	 */
	redeem: function(coupon) {
		'use strict';

		$('#modal-coupon').prop('coupon', coupon);
		$('#modal-coupon__code').text(coupon.code);
		$('#modal-coupon__balance').text('£' + coupon.balance.toFixed(2));
		$('#modal-coupon__expiry').text('Expires: ' + [
			coupon.expiry.getDate(),
			coupon.expiry.getMonth(),
			coupon.expiry.getFullYear(),
		].join('/'));

		this.$modal.open();
	},

	/**
	 * Applies the specified amount of the given coupon to the current total
	 * @param {Coupon} coupon
	 * @param {Number} amount
	 */
	apply: function(coupon, amount) {
		'use strict';

		amount = Math.max(Math.min(coupon.balance, amount), 0);
		amount = Math.min(this.total, amount);

		if(!amount) {
			return;
		}

		$('[data-coupon-applied-code]').val(coupon.code);
		$('[data-coupon-applied-amount]').val(amount.toFixed(2));
		$('[data-coupon-apply]').prop('disabled', true);

		$('#summary-coupon').css('display', 'flex');
		$('#summary-coupon__code').text(coupon.code);
		$('#summary-coupon__amount').text('-£' + amount.toFixed(2));

		$('#sidebar-coupon').show();
		$('#sidebar-coupon__code').text(coupon.code);
		$('#sidebar-coupon__amount').text('-£' + amount.toFixed(2));

		$('#checkout__total').text('£' + (this.total - amount.toFixed(2)).toFixed(2));
	},

	/**
	 * Removes any added coupon
	 */
	remove: function() {
		'use strict';

		$('[data-coupon-applied-code]').val('');
		$('[data-coupon-applied-amount]').val(0);

		$('#summary-coupon').hide();
		$('#sidebar-coupon').hide();
		$('#checkout__total').text('£' + this.total.toFixed(2));
		$('[data-coupon-apply]').prop('disabled', false);
	},
};
